import React, { FunctionComponent } from 'react';

import { Translate } from 'react-localize-redux';

import CatalogFilter from '@common/types/catalog/catalog-filter-type';

import styled from 'styled-components';

// Components
import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';

import DateAddedFilter from './date-added';

interface NFTCatalogMenuContentProps {
  className?: string;
}

const NFTCatalogMenuContent: FunctionComponent<NFTCatalogMenuContentProps> = ({
  className,
}) => {
  const [filterOption, setFilterOption] = React.useState<CatalogFilter>({});

  // TODO: DEVTEAM-603 - Integrate handleClearFilters.
  const handleClearFilters = () => {
    return;
  };

  return (
    <Content className={className || ''}>
      <Header justifyContent="space-between" alignItems="center">
        <Typography weight="700">
          <Translate id="ANALYTICS.MENU.TITLE" />
        </Typography>
        <Typography className="clear-link" onClick={handleClearFilters}>
          <Translate id="ANALYTICS.MENU.CLEAR" />
        </Typography>
      </Header>
      <Separator />
      <div>
        <DateAddedFilter
          filterOption={filterOption}
          setFilterOption={setFilterOption}
        />
        <Separator />
      </div>
    </Content>
  );
};

export default NFTCatalogMenuContent;

const Content = styled.div`
  height: 100%;
  overflow: hidden;
`;

const Header = styled(Flex)`
  margin-bottom: 30px;

  .clear-link {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.tertiary};
    transition: color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

    &:hover {
      color: ${({ theme }) => theme.colors.accent};
    }
  }
`;

const Separator = styled.span`
  display: block;
  height: 1px;
  width: 100%;
  margin-block: 20px;
  background-color: ${({ theme }) => theme.colors.secondary};

  @media ${({ theme }) => theme.device.tablet} {
    width: calc(100% + 72px);
  }
`;
